import React from 'react';
import Link from 'next/link';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import styles from '../styles/lead/Lead.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';
import Image from 'next/image';


const GetCreditReport = () => {
    return (
        <Row className={`${styles.infoBox} d-flex align-items-stretch p-3 mt-3 no-gutters`}>
            <Col xs={4} md={3} className="d-flex align-items-center justify-content-center ">         
                <Image layout="fixed" src='/images/icons/bonus-icon.png' alt='Bonus' width='70' height='70'  />
            </Col>
            
            <Col xs={8} md={9}>
                <p className={`mb-1 mb-md-0 ${styles.title} `}>Verifică situația de la Biroul de Credit</p>
                <p className={`${styles.help} mb-2`}>Beneficiezi de o verificare gratuită pe Conso.</p>
                <Link href="/user/biroul-de-credit" passHref>
                    <Button className="mx-auto" variant="outline-secondary">
                        <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="mr-2" />
                        Start
                    </Button>
                </Link>
            </Col>
        </Row>
    );
}

export default GetCreditReport;